import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslate } from 'core/translate';
import { fetchConfig } from '../../../../api/fetchConfig';
import { withModelInfo } from '../../../../common/ModelInfoContext';
import FetchTrimFeatureCompare from '../features/FetchTrimFeatureCompare';
import { useLocation, useNavigate } from 'react-router-dom';
import TrimFeatureCompare from '../../../../components/compareManager/TrimFeatureCompare';
import CapabilitiesCompare from '../../../../components/compareManager/CapabilitiesCompare';
import LoadingSpecsCompare from '../../../../common/loading/LoadingSpecsCompare';
import { useTranslate } from '../../../../../core/translate';

const FeaturesFetch = (props) => {
  const [config, setConfig] = useState(null);
  const { params, modelInfo, isCapabilities } = props;
  const { search } = useLocation();
  const navigate = useNavigate();
  const translate = useTranslate();

  const onClose = (e) => {
    e?.preventDefault();
    window?.history?.length > 1
      ? navigate(-1)
      : (document.location = location.origin);
  };

  useEffect(() => {
    const styleId = new URLSearchParams(search).get('styleId');

    const fetchConfiguration = async () => {
      try {
        const configData = await fetchConfig({
          postalCode: params.postalCode,
          styleId,
        });
        setConfig(configData);
      } catch (e) {
        console.error(e);
      }
    };
    fetchConfiguration();
  }, []);

  return (
    <div
      className={`compare__nav-padding${
        isCapabilities ? ' compare__nav-padding--capabilities' : ''
      }`}>
      {config ? (
        <FetchTrimFeatureCompare
          includeCapabilities={isCapabilities}
          config={config}
          postalCode={params.postalCode}
          render={({ features, capabilities, modelMatrix }) => (
            <>
              {isCapabilities ? (
                <CapabilitiesCompare
                  headerTitle={`${modelInfo.title} Capabilities`}
                  features={capabilities}
                  selections={config.selections}
                  config={config}
                  options={features.options}
                  onClose={onClose}
                  modelMatrix={modelMatrix}
                />
              ) : (
                <TrimFeatureCompare
                  headerTitle={translate('compare.trims.title.v3', {
                    title: modelInfo.title,
                  })}
                  options={features.options}
                  config={config}
                  features={features}
                  selections={config.selections}
                  onClose={onClose}
                  isSelectionRevealed={false}
                />
              )}
            </>
          )}
        />
      ) : (
        <LoadingSpecsCompare />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { disclaimers, params, matrix } = state;
  return {
    params,
    disclaimers,
    matrix,
  };
};

export default withModelInfo(
  connect(mapStateToProps)(withTranslate(FeaturesFetch))
);
